
















import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import * as auth from "../../_store/auth.module";
import { StudentAuthorization } from "../../_models/studentAuthorization";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class ListaAllieviIscrittiAlternanza extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;

  private listaAllievi: any;
  // private listaArticolazioni: ArticolazioneInfo[];

  // private filterParams: any;

  constructor() {
    super();
    this.titleParams = {
      title: "Allievi Iscritti",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Nome",
          value: "nomeUtente"
        },
        {
          text: "Cognome",
          value: "cognomeUtente"
        },
        {
          text: "Classe",
          value: "classe"
        },
        {
            text: "Attività",
            value: "nomeAttivita"
        },
        {
          text: "Dettagli",
          value: "action",
          sortable: false,
          width: "1%"
        },
        {
          text: "Status Patto",
          value: "reviewAutorizzazione",
          sortable: false,
          width: "8%"
        }
        // {
        //   text: "Curriculum Vitae",
        //   value: "curriculumAllievo",
        //   sortable: false,
        //   width: "8%"
        // }
        // {
        //   text: "Blocco P.C.T.O.",
        //   value: "studentsBlocks",
        //   sortable: false
        // }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      filterType: "listaAllievi",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ]
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    // this.listaArticolazioni = [];
  }

  loadStudentsList(idAnnoScolastico: number) {
    //var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var userInfo = user.readUserInfo(this["$store"]);
    var payload = {
      idIstituto: 0,
      idAnnoScolastico: 0,
      tipoAttivita: ''
    };
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      tipoAttivita: 'alternanza'
    };
    data
      .dispatchAllieviIscrittiTipoAttivita(this["$store"], payload)
      .then(result => {
        this.listaAllievi = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        bus.$emit("stopLoading");
        this["$router"].push("/login");
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    var articolazioniList: ArticolazioneInfo[];
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            data
              .dispatchArticolazioni(this["$store"], instituteInfo.id)
              .then(response => {
                response.forEach(element => {
                  this.dataTableParams.listaArticolazioni.push(element);
                });
                this.loadStudentsList(idAnnoScolastico);
              });

            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("loadStudentsList", () => {
      var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
      this.loadStudentsList(idAnnoScolastico);
    });

    bus.$on("filtroAllievi", (filters: any) => {
      const listaAllievi: any = this.listaAllievi;
      var tempList: any = [];
      var tempList2: any = [];
      var tempList3: any = [];
      var tempList4: any = [];
      this.dataTableParams.records = [];
      listaAllievi.forEach((allievo: any) => {
        if (filters.filtroAutorizzazione !== "Tutti") {
          if (filters.filtroAutorizzazione === "Inviati") {
            if (allievo.idStatoDoc === 1) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Eliminati") {
            if (allievo.idStatoDoc === 3) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Confermati") {
            if (allievo.idStatoDoc === 2) {
              tempList.push(allievo);
            }
          }
        } else {
          tempList.push(allievo);
        }
      });
      tempList.forEach((item: any) => {
        if (filters.filtroAnni !== "Tutti") {
          if (filters.filtroAnni === "3") {
            if (item.classe.charAt(0) === "3") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "4") {
            if (item.classe.charAt(0) === "4") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "5") {
            if (item.classe.charAt(0) === "5") {
              tempList2.push(item);
            }
          }
        } else {
          tempList2.push(item);
        }
      });
      tempList2.forEach((item: any) => {
        if (filters.fitroArticolazione !== "Tutte") {
          if (filters.fitroArticolazione === "IT01") {
            if (item.idArticolazione === "IT01") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT04") {
            if (item.idArticolazione === "IT04") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT05") {
            if (item.idArticolazione === "IT05") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT10") {
            if (item.idArticolazione === "IT10") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT13") {
            if (item.idArticolazione === "IT13") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITAF") {
            if (item.idArticolazione === "ITAF") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITEN") {
            if (item.idArticolazione === "ITEN") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITET") {
            if (item.idArticolazione === "ITET") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITIA") {
            if (item.idArticolazione === "ITIA") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITMM") {
            if (item.idArticolazione === "ITMM") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "LI03") {
            if (item.idArticolazione === "LI03") {
              tempList3.push(item);
            }
          }
        } else {
          tempList3.push(item);
        }
      });
      tempList3.forEach((item: any) => {
        if (filters.filtroSezione != "Nessuna") {
          if (filters.filtroSezione === "A") {
            if (item.classe.charAt(2) === "A") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "B") {
            if (item.classe.charAt(2) === "B") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "C") {
            if (item.classe.charAt(2) === "C") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "D") {
            if (item.classe.charAt(2) === "D") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "E") {
            if (item.classe.charAt(2) === "E") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "F") {
            if (item.classe.charAt(2) === "F") {
              tempList4.push(item);
            }
          }
        } else {
          tempList4.push(item);
        }
      });
      this.dataTableParams.records = tempList4;
    });

    bus.$on("changeAnnoScolastico", (payload: any) => {
      this.loadStudentsList(payload);
    });
  }
}
